
















































import { Component, Prop, Emit } from 'nuxt-property-decorator'
import { ComponentVue } from '@/base'
import { appStore } from '@/store'

@Component
export default class AtomTextArea extends ComponentVue {
  @Prop({ type: [Number, String], default: 5 })
  rows!: number | string

  @Prop({ type: Boolean, default: false })
  limitLinefeed!: boolean

  @Prop({ type: Boolean, default: true })
  hideDetails!: boolean

  @Prop({ type: Boolean, default: true })
  noResize!: boolean

  @Prop({ type: Boolean, default: false })
  readonly!: boolean

  @Prop({ type: Boolean, default: false })
  flat!: boolean

  @Prop({ type: String, default: '' })
  value!: string

  @Prop({ type: Boolean, default: false })
  outlined!: boolean

  @Prop({ type: String, default: '' })
  appendIcon!: string

  @Prop({ type: Boolean, default: false })
  error!: boolean

  @Prop({ type: String })
  maxlength!: string

  @Prop({ type: String, default: '' })
  errorMessage!: string

  @Prop({ type: Boolean, default: false })
  autofocus!: boolean

  get styles(): object {
    if (this.fontSizeType === 'normal') {
      return {}
    }

    return {
      'font-size': this.fontSize + 'px'
    }
  }

  get fontSize(): number {
    return appStore._fontSizeNormal
  }

  get fontSizeType(): string {
    return appStore._fontSizeType
  }

  get isError(): boolean {
    return this.error || this.errorMessage !== ''
  }

  @Emit('input')
  onInput(value: string | null) {
    if (value === null) return ''
    return value
  }

  @Emit('blur')
  onBlur() {}

  @Emit('click:append')
  onClickAppend() {}
}
